const EMPTY_FIELDS = Object.freeze([]);
const HIGH_RISK_EMPTY_RULE = Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS });
export const REQUEST_BODY_PROTECT_PREFIX = 'BXR1';

const REQUEST_SECURITY_RULES = Object.freeze({
	'/login': Object.freeze({ highRisk: true, encryptedFields: Object.freeze(['password']) }),
	'/register': Object.freeze({ highRisk: true, encryptedFields: Object.freeze(['password', 'code']) }),
	'/resetPwd': Object.freeze({ highRisk: true, encryptedFields: Object.freeze(['password', 'code']) }),
	'/modifyPwd': Object.freeze({ highRisk: true, encryptedFields: Object.freeze(['oldPassword', 'newPassword']) }),
	'/refreshToken': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/captcha/sms/code': Object.freeze({ highRisk: true, encryptedFields: Object.freeze(['code']) }),
	'/captcha/sms/vertify': Object.freeze({ highRisk: true, encryptedFields: Object.freeze(['code']) }),
	'/captcha/img/vertify': Object.freeze({ highRisk: true, encryptedFields: Object.freeze(['code']) }),
	'/image/upload/init': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/image/upload/complete': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/video/upload/init': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/video/upload/complete': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/file/upload/init': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/file/upload/complete': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/audio/upload/init': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/audio/upload/complete': Object.freeze({ highRisk: true, encryptedFields: EMPTY_FIELDS }),
	'/qrLogin/generate': HIGH_RISK_EMPTY_RULE,
	'/qrLogin/scan': HIGH_RISK_EMPTY_RULE,
	'/qrLogin/confirm': HIGH_RISK_EMPTY_RULE
});

const REQUEST_SECURITY_PATTERN_RULES = Object.freeze([
	Object.freeze({ pattern: /^\/qrLogin\/status\/[^/]+$/, rule: HIGH_RISK_EMPTY_RULE }),
	Object.freeze({ pattern: /^\/qrLogin\/cancel\/[^/]+$/, rule: HIGH_RISK_EMPTY_RULE })
]);

export function normalizeRequestPath(url) {
	const rawUrl = String(url || '');
	if (!rawUrl) {
		return '';
	}
	try {
		const parsed = /^https?:\/\//i.test(rawUrl)
			? new URL(rawUrl)
			: new URL(rawUrl, window.location.origin);
		return parsed.pathname;
	} catch (e) {
		return rawUrl.split('?')[0];
	}
}

function matchSecurityRule(url) {
	const path = normalizeRequestPath(url);
	if (!path) {
		return null;
	}
	const exactRule = REQUEST_SECURITY_RULES[path];
	if (exactRule) {
		return exactRule;
	}
	const patternRule = REQUEST_SECURITY_PATTERN_RULES.find((item) => item.pattern.test(path));
	return patternRule ? patternRule.rule : null;
}

export function isHighRiskRequest(url) {
	const rule = matchSecurityRule(url);
	return Boolean(rule && rule.highRisk);
}

export function getEncryptedFieldNames(url) {
	const rule = matchSecurityRule(url);
	if (!rule || !Array.isArray(rule.encryptedFields)) {
		return EMPTY_FIELDS;
	}
	return rule.encryptedFields;
}
